export default __webpack_public_path__ + "static/integrations-wheel-1d77d6debc069f13dde22e147524222a.mp4";